import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import Clipboard from 'clipboard';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import { showModal, hideModal } from '../../../actions/ModalActions';
import { fetchGuestList, getGuestGroup, toggleInvited, toggleAllGuestsFacetValue, toggleSortByNameAsc } from '../../../actions/GuestActions'; // eslint-disable-line
import Address from '../../common/ui/Address';
import Loader from '../../common/ui/Loader';
import StickyHeaderTable from '../../common/ui/StickyHeaderTable';
import GlobalStats from '../common/GlobalStats';
import Facets from './Facets';
import { PrefixToLabel } from './GuestListTypes';
import NoGuests from './NoGuests';
// import Banner from '../common/Banner';
import { isCompleteAddress, isMissingAddress, isNameUnknown, getIncompleteAddressGuestGroupIds } from './util';


class GuestGroupRow extends Component {
  constructor(props) {
    super(props);

    this.rowCheck = this.rowCheck.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.toggleInvited = this.toggleInvited.bind(this);

    this.state = {
      active: false,
      timeout: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { modalOpen, onSelectGuestGroup } = this.props;
    if (modalOpen && (nextProps.modalOpen === false)) {
      this.setState({
        timeout: setTimeout(() => onSelectGuestGroup(null), 1000)
      });
    }
  }

  componentWillUnmount() {
    const { timeout } = this.state;
    if (timeout) {
      clearTimeout(timeout);
    }
  }

  rowCheck() {
    const { guestGroup, onRowCheck, isRowChecked } = this.props;
    onRowCheck(guestGroup.id, !isRowChecked);
  }

  rowClick(e) {
    const { guestGroup, onEditGuestGroup, onSelectGuestGroup } = this.props;
    if (e.target.hasAttribute('data-no-edit')) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    } else {
      onEditGuestGroup(guestGroup.id);
      onSelectGuestGroup(guestGroup.id);
    }
  }

  toggleInvited(invited) {
    const { guestGroup, onToggleInvited } = this.props;
    const eventInvitations = _.flatMap(guestGroup.guests, guest => guest.event_invitations);
    const hasResponses = eventInvitations.some(eventInvitation => eventInvitation.rsvp_at !== null);
    onToggleInvited([guestGroup.id], invited, hasResponses);
  }

  render() {
    const {
      wedding,
      guestGroup,
      onDeleteGuestGroups,
      onSelectGuestGroup,
      onGuestMessage,
      onRequestMissingInfo,
      isRowChecked,
      isActive
    } = this.props;

    if (!guestGroup || !guestGroup.guests) return null;

    const [primaryGuests, otherGuests] = _.partition(guestGroup.guests, guest => guest.relationship_type === 'PRIMARY');
    const primaryGuest = primaryGuests[0] || otherGuests[0];

    const address = {
      address1: guestGroup.address_1,
      address2: guestGroup.address_2,
      city: guestGroup.city,
      state: guestGroup.state_province,
      zip: guestGroup.postal_code,
      countryCode: guestGroup.country_code
    };

    const GUEST_AFFILIATION = {
      UNKNOWN: '',
      PRIMARY_FAMILY: 'Primary\'s Family',
      PRIMARY_WEDDING_PARTY: 'Primary\'s Wedding Party',
      PRIMARY_FRIEND: 'Primary\'s Friend',
      PRIMARY_FAMILY_FRIEND: 'Primary\'s Family Friend',
      PARTNER_FAMILY: 'Partner\'s Family',
      PARTNER_WEDDING_PARTY: 'Partner\'s Wedding Party',
      PARTNER_FRIEND: 'Partner\'s Friend',
      PARTNER_FAMILY_FRIEND: 'Partner\'s Family Friend',
      BOTH: 'Primary and Partner\'s Friend',
    };

    const injectCoupleNames = (primaryName, partnerName) => (
      affiliation => affiliation.replace('Primary\'s', `${primaryName}'s`).replace('Primary', primaryName).replace('Partner\'s', `${partnerName}'s`)
    );

    const relationshipToCouple = injectCoupleNames(wedding.owner_first_name, wedding.partner_first_name);

    return (
      <tr className={isActive ? 'table-row table-row-active' : 'table-row'} onClick={this.rowClick} onMouseEnter={() => onSelectGuestGroup(guestGroup.id)}>
        <td className="td-checkbox">
          <div className="checkbox checkbox-table checkbox-secondary">
            <label htmlFor={`guests-${guestGroup.id}`}>
              <input
                type="checkbox"
                id={`guests-${guestGroup.id}`}
                data-no-edit
                checked={isRowChecked}
                onClick={this.rowCheck}
              />
              <span className="input-override" data-no-edit><i className="zolaicon zolaicon-checkmark" data-no-edit /></span>
            </label>
          </div>
        </td>
        <td className="guest-group-list">
          <div className="primary-guest-name">{PrefixToLabel[primaryGuest.prefix]} {primaryGuest.first_name} <strong>{primaryGuest.family_name}</strong></div>
          <ul className="list-indent">
            {otherGuests.length > 0 && otherGuests.map(otherGuest => (
              <li key={otherGuest.id}>
                {isNameUnknown(otherGuest) ? (
                  <span>{(otherGuest.relationship_type === 'CHILD') ? 'Child' : 'Guest'}</span>
                ) : (
                  <span>{PrefixToLabel[otherGuest.prefix]} {otherGuest.first_name} {otherGuest.family_name}</span>
                )}
              </li>
            ))}
            <li className="relationship-type text-muted">{relationshipToCouple(GUEST_AFFILIATION[guestGroup.affiliation])}</li>
          </ul>
        </td>
        <td>{guestGroup.guests.length}</td>
        <td className="contact-info">
          {guestGroup.email_address ? (
            <div>{guestGroup.email_address}</div>
          ) : (
            <div className="text-muted">No Email</div>
          )}
          {guestGroup.mobile_phone ? (
            <div>{guestGroup.mobile_phone}</div>
          ) : (
            <div className="text-muted">No Mobile</div>
          )}
        </td>
        <td className="mailing-address">
          {isCompleteAddress(address) ? (
            <Address {...address} />
          ) : (
            <div className="incomplete-mailing-address">
              <div className="text-danger">{isMissingAddress(address) ? 'Missing Address' : 'Incomplete Address'}</div>
              {guestGroup.email_address && (
                <div className="request-missing-info">
                  <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Missing a guest's address or contact information? We'll help you collect it.">
                    <button className="btn-link btn-link-cta" data-no-edit onClick={() => onRequestMissingInfo([guestGroup.id])}>Request Missing Info›</button>
                  </div>
                  {(guestGroup.collect_addresses_message_sent_at && guestGroup.collect_address_copied_at) && (
                    <div>
                      {moment(guestGroup.collect_addresses_message_sent_at).isAfter(moment(guestGroup.collect_address_copied_at)) ? (
                        <i className="text-muted">Sent Request {moment.utc(guestGroup.collect_addresses_message_sent_at).format('MM/DD/YY')}</i>
                      ) : (
                        <i className="text-muted">Copied Link {moment.utc(guestGroup.collect_address_copied_at).format('MM/DD/YY')}</i>
                      )}
                    </div>
                  )}
                  {(guestGroup.collect_addresses_message_sent_at && !guestGroup.collect_address_copied_at) && (
                    <div>
                      <i className="text-muted">Sent Request {moment.utc(guestGroup.collect_addresses_message_sent_at).format('MM/DD/YY')}</i>
                    </div>
                  )}
                  {(!guestGroup.collect_addresses_message_sent_at && guestGroup.collect_address_copied_at) && (
                    <div>
                      <i className="text-muted">Copied Link {moment.utc(guestGroup.collect_address_copied_at).format('MM/DD/YY')}</i>
                    </div>
                  )}
                </div>
              )}
              {!guestGroup.email_address && (
                <div className="request-missing-info">
                  <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Missing a guest's address or contact information? We'll help you collect it.">
                    <button className="btn-link btn-link-cta" data-no-edit onClick={() => onRequestMissingInfo([guestGroup.id])}>Request Missing Info›</button>
                  </div>
                  <div>
                    {guestGroup.collect_address_copied_at && (
                      <i className="text-muted">Copied Link {moment.utc(guestGroup.collect_address_copied_at).format('MM/DD/YY')}</i>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </td>
        <td className="guestlist-radio">
          <label className="radio-inline guestlist-radio" htmlFor={`${guestGroup.id}-invited-yes`} data-no-edit>
            <input
              type="radio"
              id={`${guestGroup.id}-invited-yes`}
              checked={guestGroup.invited}
              onChange={() => this.toggleInvited(true)}
              data-no-edit
            />
            <span className="input-override" data-no-edit />
            Definitely
          </label>
          <label className="radio-inline guestlist-radio" htmlFor={`${guestGroup.id}-invited-no`} data-no-edit>
            <input
              type="radio"
              id={`${guestGroup.id}-invited-no`}
              checked={!guestGroup.invited}
              onChange={() => this.toggleInvited(false)}
              data-no-edit
            />
            <span className="input-override" data-no-edit />
            Maybe
          </label>
        </td>
        <td>
          {guestGroup.email_address ? (
            <span className="margin-right with-tooltip" data-tooltip="Send a message">
              <button className="btn btn-icon" onClick={() => onGuestMessage([guestGroup.id])} data-no-edit>
                <i style={{ fontSize: '25px' }} className="zolaicon zolaicon-email" data-no-edit />
              </button>
            </span>
          ) : (
            <span className="margin-right with-tooltip" data-tooltip="Add guest's email to send a message">
              <button className="btn btn-icon btn-disabled" data-no-edit>
                <i style={{ fontSize: '25px' }} className="zolaicon zolaicon-email" data-no-edit />
              </button>
            </span>
          )}
          <span className="margin-left with-tooltip" data-tooltip="Delete guest">
            <button className="btn btn-icon" onClick={() => onDeleteGuestGroups([guestGroup.id])} data-no-edit>
              <i className="glyphicon glyphicon-trash" data-no-edit />
            </button>
          </span>
        </td>
      </tr>
    );
  }
}

GuestGroupRow.propTypes = {
  guestGroup: PropTypes.shape({}),
  onToggleInvited: PropTypes.func.isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  onDeleteGuestGroups: PropTypes.func.isRequired,
  wedding: PropTypes.shape({
    owner_first_name: PropTypes.string,
    partner_first_name: PropTypes.string,
  }),
  onGuestMessage: PropTypes.func.isRequired,
  onRowCheck: PropTypes.func.isRequired,
  isRowChecked: PropTypes.bool.isRequired,
  onSelectGuestGroup: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool,
  isActive: PropTypes.bool,
  onRequestMissingInfo: PropTypes.func,
};

class GuestsHeader extends Component { // eslint-disable-line
  render() {
    const { checkAllRows, checkedAllRows, onToggleSort, sortByNameAsc, style } = this.props;

    return (
      <thead className="table-header" style={style}>
        <tr>
          <th className="td-checkbox">
            <div className="checkbox checkbox-table">
              <label htmlFor="guests-select-all">
                <input
                  type="checkbox"
                  id="guests-select-all"
                  onClick={checkAllRows}
                  checked={checkedAllRows}
                />
                <span className="input-override"><div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Select all guests on this page."><i className="zolaicon zolaicon-checkmark" /></div></span>
              </label>
            </div>
          </th>
          <th className="sortable" role="button" onClick={onToggleSort} ><div className="with-tooltip no-tooltip-on-mobile" data-tooltip="View guests by last name, ascending or descending."><span className="tooltip-span">Name<i className={`zolaicon zolaicon-arrow-${sortByNameAsc ? 'up' : 'down'}`} /></span></div></th>
          <th><div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Total guests in party"><span className="tooltip-span">NO.</span></div></th>
          <th>Email &amp; Mobile</th>
          <th>Mailing Address</th>
          <th><div className="with-tooltip" data-tooltip="Tame your guest list with these filters by marking who's &quot;Definitely&quot; and &quot;Maybe&quot; invited."><span className="tooltip-span">Invited?</span><i className="zolaicon zolaicon-info visible-xs-inline visible-sm-inline" /></div></th>
          <th>&nbsp;</th>
        </tr>
      </thead>
    );
  }
}

GuestsHeader.defaults = {
  style: {}
};

GuestsHeader.propTypes = {
  checkAllRows: PropTypes.func.isRequired,
  checkedAllRows: PropTypes.bool.isRequired,
  onToggleSort: PropTypes.func.isRequired,
  sortByNameAsc: PropTypes.bool.isRequired,
  style: PropTypes.objectOf(PropTypes.string)
};

// must be a class component for sticky header to work properly
class GuestsTable extends Component { // eslint-disable-line
  render() {
    const {
      headerStyle,
      checkAllRows,
      checkedAllRows,
      onToggleSort,
      sortByNameAsc,
      filteredIds,
      guestGroups,
      editGuestModalOpen,
      selectedGuestGroupId,
      onToggleInvited,
      onEditGuestGroup,
      onDeleteGuestGroups,
      wedding,
      onGuestMessage,
      checkedRows,
      checkRow,
      onSelectGuestGroup,
      onRequestMissingInfo,
      tableId,
    } = this.props;

    return (
      <table className="table guest-table-v2 table-fixed-header-round round-bottom" id={tableId}>
        <GuestsHeader
          checkAllRows={checkAllRows}
          checkedAllRows={checkedAllRows}
          onToggleSort={onToggleSort}
          sortByNameAsc={sortByNameAsc}
          style={headerStyle}
        />
        <tbody>
          {filteredIds.map(guestGroupId => (
            <GuestGroupRow
              key={guestGroupId}
              guestGroup={guestGroups[guestGroupId]}
              modalOpen={editGuestModalOpen}
              isActive={guestGroupId === selectedGuestGroupId}
              onToggleInvited={onToggleInvited}
              onEditGuestGroup={onEditGuestGroup}
              onDeleteGuestGroups={onDeleteGuestGroups}
              wedding={wedding}
              onGuestMessage={onGuestMessage}
              isRowChecked={_.includes(checkedRows, guestGroupId)}
              onRowCheck={checkRow}
              onSelectGuestGroup={onSelectGuestGroup}
              onRequestMissingInfo={onRequestMissingInfo}
            />
          ))}
        </tbody>
      </table>
    );
  }
}

GuestsTable.defaults = {
  headerStyle: {},
  selectedGuestGroupId: null
};

GuestsTable.propTypes = {
  headerStyle: PropTypes.objectOf(PropTypes.string),
  checkedAllRows: PropTypes.bool.isRequired,
  sortByNameAsc: PropTypes.bool.isRequired,
  editGuestModalOpen: PropTypes.bool.isRequired,
  selectedGuestGroupId: PropTypes.number,
  filteredIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  checkedRows: PropTypes.arrayOf(PropTypes.number).isRequired,
  guestGroups: PropTypes.shape({}).isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  onToggleSort: PropTypes.func.isRequired,
  checkRow: PropTypes.func.isRequired,
  checkAllRows: PropTypes.func.isRequired,
  onSelectGuestGroup: PropTypes.func.isRequired,
  onRequestMissingInfo: PropTypes.func.isRequired,
  onToggleInvited: PropTypes.func.isRequired,
  onDeleteGuestGroups: PropTypes.func.isRequired,
  onGuestMessage: PropTypes.func.isRequired,
  wedding: PropTypes.shape({}).isRequired,
  tableId: PropTypes.string,
};

class GuestDirectory extends Component {
  constructor(props) {
    super(props);

    this.checkRow = this.checkRow.bind(this);
    this.checkAllRows = this.checkAllRows.bind(this);
    this.unCheckAllRows = this.unCheckAllRows.bind(this);
    this.resetFacets = this.resetFacets.bind(this);
    this.resetAll = this.resetAll.bind(this);
    this.afterExport = this.afterExport.bind(this);
    this.toggleGuestBreakdown = this.toggleGuestBreakdown.bind(this);
    this.showAllGuests = this.showAllGuests.bind(this);

    this.state = {
      checkedRows: [],
      checkedAllRows: false,
      clipboard: undefined,
      // showGuestBreakdown: false,
    };
  }

  componentDidMount() {
    const { getGuestList, getEvents } = this.props;
    getGuestList();
    getEvents();
    this.initializeClipboard();
  }

  componentWillReceiveProps(nextProps) {
    const { filteredIds } = nextProps;
    const { checkedRows } = this.state;

    const nextCheckedRows = _.intersection(checkedRows, filteredIds);
    const nextCheckedAllRows = nextCheckedRows.length !== 0 && nextCheckedRows.length === filteredIds.length;

    this.setState({
      checkedRows: nextCheckedRows,
      checkedAllRows: nextCheckedAllRows,
    });
  }

  componentWillUnmount() {
    const { onUnload } = this.props;
    onUnload();
    this.destroyClipboard();
    this.resetAll();
  }

  checkRow(id, isChecked) {
    const { filteredIds } = this.props;
    const { checkedRows } = this.state;

    if (isChecked) {
      checkedRows.push(id);
    } else {
      _.pull(checkedRows, id);
    }

    this.setState({
      checkedRows,
      checkedAllRows: filteredIds.length === checkedRows.length
    });
  }

  checkAllRows() {
    const { filteredIds } = this.props;
    const checkedAllState = !this.state.checkedAllRows;

    this.setState({
      checkedRows: checkedAllState ? filteredIds.slice() : [],
      checkedAllRows: checkedAllState
    });
  }

  unCheckAllRows() {
    this.setState({
      checkedRows: [],
      checkedAllRows: false
    });
  }

  initializeClipboard() {
    const clipboard = new Clipboard('.collect-address-copy');

    clipboard.on('success', (e) => {
      const target = e.trigger;
      target.setAttribute('data-tooltip', 'Copied!');
      setTimeout(() => {
        target.removeAttribute('data-tooltip');
      }, 1000);
    });

    clipboard.on('error', () => {
      let clipboardErrorMessage = '';
      if (/iPhone|iPad/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Select and copy.';
      } else if (/Mac/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Press ⌘-C to copy.';
      } else {
        clipboardErrorMessage = 'Press Ctrl-C to copy.';
      }
      this.setState({ clipboardErrorMessage });
      setTimeout(() => this.setState({ clipboardErrorMessage: undefined }), 5000);
    });

    this.setState({ clipboard });
  }

  destroyClipboard() {
    const { clipboard } = this.state;
    if (clipboard) clipboard.destroy();
    this.setState({
      clipboard: undefined
    });
  }

  afterExport() {
    const { onConfirmation } = this.props;
    this.exportDropdown.hide();
    onConfirmation('Guest List Exported');
  }

  resetFacets() {
    const { onResetFacets, getGuestList } = this.props;
    onResetFacets();
    getGuestList();
  }

  resetAll() {
    const { onResetFacets, onResetSearchValue, onSelectGuestGroup } = this.props; // eslint-disable-line
    onResetSearchValue();
    // onResetFacets();
    onSelectGuestGroup(null);
  }

  toggleGuestBreakdown() {
    this.setState(state => ({
      showGuestBreakdown: !state.showGuestBreakdown
    }));
  }

  showAllGuests() {
    const { onResetFacets, onResetSearchValue, getGuestList } = this.props;
    onResetSearchValue();
    onResetFacets();
    getGuestList();
  }

  render() {
    const {
      onRequestMissingInfo,
      onGuestMessage,
      onToggleFacet,
      wedding,
      onAddGuestGroup,
      guestGroups,
      onToggleInvited,
      onEditGuestGroup,
      globalStats,
      numGuests,
      numSelectedFacets,
      onDeleteGuestGroups,
      sortByNameAsc,
      onToggleSort,
      selectedFacetValues,
      editGuestModalOpen,
      initialized,
      onEnableGuestListOnboarding,
      onSearchFilterGuestList,
      searchValue,
      filteredIds,
      onSelectGuestGroup,
      selectedGuestGroupId,
    } = this.props;

    const { checkedRows, checkedAllRows } = this.state;

    if (!initialized) {
      return (
        <div className="guestlist-loader">
          <Loader delay />
        </div>
      );
    }

    let definitelyInvitedCount;
    if (_.find(globalStats, { key: 'invited_guests' })) {
      definitelyInvitedCount = _.find(globalStats, { key: 'invited_guests' }).value;
    }
    const formattedGlobalStats = [];
    const formattedGuestAgeStats = [];
    let numGuestsAttending = 0;

    globalStats.forEach((globalStat) => {
      if (globalStat.key === 'addresses_missing' && globalStat.value > 0) {
        formattedGlobalStats.push(Object.assign({}, globalStat, { isLink: true, linkAttrs: { role: 'button', onClick: () => onRequestMissingInfo(getIncompleteAddressGuestGroupIds(guestGroups)) }, tooltip: 'We\'ll help you collect all of these. Click on "Missing Addresses" to begin.' }));
      } else if (globalStat.key === 'guests' && globalStat.value === definitelyInvitedCount) {
        formattedGlobalStats.push(Object.assign({}, globalStat, { hidden: true }));
      } else if (globalStat.key === 'guests' && globalStat.value !== definitelyInvitedCount) {
        formattedGlobalStats.push(Object.assign({}, globalStat, { hidden: false, tooltip: 'Total guests added' }));
      } else if (globalStat.key === 'invited_guests' && globalStat.value > 0) {
        formattedGlobalStats.push(globalStat);
      } else if (globalStat.key === 'adults' || globalStat.key === 'children') {
        numGuestsAttending += globalStat.value;
        formattedGuestAgeStats.push(globalStat);
      } else {
        formattedGlobalStats.push(globalStat);
      }
    });
    const production = window.zola.env === 'production';

    return (
      <div>
        <div>
          {numGuests === 0 ? (
            <div>
              <div className="content-top">
                <div className="row">
                  <div className="col-xs-12 navbar-default">
                    <h1 className="page-heading col-xs-12 col-sm-6">All Guests</h1>
                  </div>
                </div>
              </div>
              <NoGuests onAddGuestGroup={onAddGuestGroup} onEnableGuestListOnboarding={onEnableGuestListOnboarding} />
            </div>
          ) : (
            <div>
              <div className="content-top">
                <div className="row">
                  <div className="col-xs-12 navbar-default">
                    <h1 className="page-heading col-xs-12 col-sm-6">All Guests</h1>
                    <div className="nav navbar-nav navbar-right">
                      <ul className="list-inline">
                        <li className="with-tooltip no-tooltip-on-mobile" data-tooltip="Exports guest information to a spreadsheet">
                          <Dropdown ref={(c) => { this.exportDropdown = c; }}>
                            <DropdownTrigger className="btn btn-secondary navbar-btn">Export Guests <i className="zolaicon zolaicon-chevron-down" /></DropdownTrigger>
                            <DropdownContent className="">
                              <ul className="dropdown-menu dropdown-menu-right">
                                <li>
                                  <a href="/web-api/v1/guestgroup/export/guest-excel" onClick={this.afterExport}>Export Excel Format</a>
                                </li>
                                <li>
                                  <a href="/web-api/v1/guestgroup/export/all" onClick={this.afterExport}>Export .csv Format</a>
                                </li>
                              </ul>
                            </DropdownContent>
                          </Dropdown>
                        </li>
                        <li>
                          <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Manually enter guests, import an existing spreadsheet, or send a link to guests that collects their information.">
                            <button className="btn btn-primary navbar-btn" onClick={() => onAddGuestGroup()}>+ Add Guests</button>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {numGuestsAttending > 0 && (
                    <div>
                      <div className="global-stats-container">
                        <ul className="nav navbar-nav navbar-left" style={{ paddingLeft: '14px' }}>
                          <li className="first-set"><GlobalStats stats={formattedGlobalStats} /></li>
                          <li className="second-set"><GlobalStats stats={formattedGuestAgeStats} /></li>
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="main-content table guest-table">
                <div className="row">
                  <div className="col-xs-12">
                    <div className="col-xs-12 navbar-default">
                      <div className="nav navbar-nav navbar-left">
                        {checkedRows.length > 0 ? (
                          <ul className="list-inline">
                            <li>
                              <Dropdown ref={(c) => { this.bulkActionsDropdown = c; }}>
                                <DropdownTrigger className="btn-dropdown btn-dropdown-secondary navbar-btn btn btn-boxed">
                                  <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Perform actions on multiple guests at once.">
                                    <span>Bulk Actions</span>
                                    <i className="zolaicon zolaicon-chevron-down" />
                                  </div>
                                </DropdownTrigger>
                                <DropdownContent>
                                  <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-left">
                                    <li><a role="button" onClick={() => { onRequestMissingInfo(checkedRows); this.bulkActionsDropdown.hide(); }}>Request Missing Info</a></li>
                                    <li><a role="button" onClick={() => { onGuestMessage(checkedRows); this.bulkActionsDropdown.hide(); }}>Send Message</a></li>
                                    <li><a role="button" onClick={() => { onToggleInvited(checkedRows, true); this.bulkActionsDropdown.hide(); }}>Set to &ldquo;Definitely Invited&rdquo;</a></li>
                                    <li><a role="button" onClick={() => { onToggleInvited(checkedRows, false, true); this.bulkActionsDropdown.hide(); }}>Set to &ldquo;Maybe Invited&rdquo;</a></li>
                                    <li><a role="button" onClick={() => { onDeleteGuestGroups(checkedRows); this.bulkActionsDropdown.hide(); }}>Delete</a></li>
                                  </ul>
                                </DropdownContent>
                              </Dropdown>
                            </li>
                            <li>
                              {checkedRows.length} Selected. <a role="button" onClick={this.unCheckAllRows}>Clear Selection</a>
                            </li>
                          </ul>
                        ) : (
                          <ul className={production ? 'list-inline filter-search-ul' : 'list-inline filter-search-ul-v2'}>
                            <li>
                              <Dropdown>
                                <DropdownTrigger className="btn-dropdown navbar-btn btn btn-boxed">
                                  {numSelectedFacets ? (
                                    <span>{numSelectedFacets} Filters Selected</span>
                                  ) : (
                                    <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="View specific groups of guests and perform bulk actions."><span>Filter Guests ({numGuests})</span></div>
                                  )}
                                  <i className="zolaicon zolaicon-chevron-down" />
                                </DropdownTrigger>
                                <DropdownContent>
                                  <div className="dropdown-menu dropdown-menu-left">
                                    <Facets selectedFacetValues={selectedFacetValues} onToggleFacet={onToggleFacet} onResetFacets={this.resetFacets} />
                                  </div>
                                </DropdownContent>
                              </Dropdown>
                            </li>
                            <li>
                              <div className="has-feedback has-feedback-left">
                                <span className="zolaicon clear-search hidden" />
                                <i className="glyphicon glyphicon-search form-control-feedback hidden-xs hidden-sm" />
                                <input
                                  className="form-control search"
                                  type="search"
                                  placeholder="Search Guest List"
                                  onChange={e => onSearchFilterGuestList(e)}
                                  value={searchValue}
                                />
                              </div>
                            </li>
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {filteredIds.length === 0 ? (
                    <div className="col-xs-12 text-center">
                      <h3>No Results Found</h3>
                      <p>Try adjusting your search or filter to find what you&apos;re looking for.</p>
                      <button className="btn btn-primary margin-top-2x" onClick={this.showAllGuests}>Show All Guests</button>
                    </div>
                    ) : (
                      <div className="col-xs-12">
                        {filteredIds.length > 0 &&
                        <StickyHeaderTable
                          StaticTable={GuestsTable}
                          StickyHeader={GuestsHeader}
                          dataPropName={'guestGroups'}
                          stickyHeaderCls="table guest-table-v2"
                          checkAllRows={this.checkAllRows}
                          checkedAllRows={checkedAllRows}
                          onToggleSort={onToggleSort}
                          sortByNameAsc={sortByNameAsc}
                          filteredIds={filteredIds}
                          guestGroups={guestGroups}
                          editGuestModalOpen={editGuestModalOpen}
                          selectedGuestGroupId={selectedGuestGroupId}
                          onToggleInvited={onToggleInvited}
                          onEditGuestGroup={onEditGuestGroup}
                          onDeleteGuestGroups={onDeleteGuestGroups}
                          wedding={wedding}
                          onGuestMessage={onGuestMessage}
                          checkedRows={checkedRows}
                          checkRow={this.checkRow}
                          onSelectGuestGroup={onSelectGuestGroup}
                          onRequestMissingInfo={onRequestMissingInfo}
                        />
                      }
                      </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

GuestDirectory.propTypes = {
  getGuestList: PropTypes.func.isRequired,
  onAddGuestGroup: PropTypes.func.isRequired,
  onToggleInvited: PropTypes.func.isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  guestGroups: PropTypes.shape({}),
  globalStats: PropTypes.arrayOf(PropTypes.shape({})),
  numGuests: PropTypes.number,
  numSelectedFacets: PropTypes.number,
  onDeleteGuestGroups: PropTypes.func.isRequired,
  wedding: PropTypes.shape({}),
  onToggleFacet: PropTypes.func.isRequired,
  onGuestMessage: PropTypes.func.isRequired,
  sortByNameAsc: PropTypes.bool,
  onToggleSort: PropTypes.func.isRequired,
  onResetFacets: PropTypes.func.isRequired,
  selectedFacetValues: PropTypes.shape({}),
  onUnload: PropTypes.func.isRequired,
  editGuestModalOpen: PropTypes.bool,
  initialized: PropTypes.bool,
  onConfirmation: PropTypes.func,
  onRequestMissingInfo: PropTypes.func,
  onEnableGuestListOnboarding: PropTypes.func,
  getEvents: PropTypes.func,
  onSearchFilterGuestList: PropTypes.func,
  searchValue: PropTypes.string,
  filteredIds: PropTypes.arrayOf(PropTypes.number),
  selectedGuestGroupId: PropTypes.number,
  onResetSearchValue: PropTypes.func,
  onSelectGuestGroup: PropTypes.func,
};

const mapStateToProps = state => ({
  wedding: state.wedding.wedding,
});

const mapDispatchToProps = dispatch => ({
  getGuestList: () => dispatch(fetchGuestList()),
  onAddGuestGroup: guestGroupType => dispatch(showModal('ADD_GUEST_GROUP_V2', { callback: () => dispatch(fetchGuestList()), guestGroupType })),
  onEditGuestGroup: (guestGroupId, activeTab) => {
    const callback = () => dispatch(fetchGuestList());
    return dispatch(getGuestGroup(guestGroupId))
      .then(() => dispatch(showModal('EDIT_GUEST_GROUP_V2', { guestGroupId, activeTab, callback })));
  },
  onToggleInvited: (guestGroupIds, isInvited, hasResponses) => {
    if (isInvited) {
      dispatch(toggleInvited(guestGroupIds, isInvited, fetchGuestList));
    } else if (hasResponses) {
      const onConfirmAction = () => dispatch(toggleInvited(guestGroupIds, isInvited, fetchGuestList)).then(() => dispatch(hideModal()));
      dispatch(showModal('UNINVITE_GUEST_CONFIRMATION', { onConfirmAction }, { size: 'md' }));
    } else {
      dispatch(toggleInvited(guestGroupIds, isInvited, fetchGuestList));
    }
  },
  onDeleteGuestGroups: guestGroupIds => dispatch(showModal('DELETE_GUEST_GROUP', { guestGroupIds })),
  onToggleFacet: (facetKey, facetValue) => dispatch(toggleAllGuestsFacetValue(facetKey, facetValue)),
  onToggleSort: () => {
    dispatch(toggleSortByNameAsc());
    dispatch(fetchGuestList());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GuestDirectory);



/** WEBPACK FOOTER **
 ** ./src/components/manage/guestlist/Directory.jsx
 **/